import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const RetailerEmptyState = {
  retailers: [],
  selectedRetailer: null,
  selectedDashboardRetailer: [],
};

export const RetailerKey = 'retailers';

export const retailersSlice = createSlice({
  name: 'retailers',
  initialState: getLocalStorage(LocalStorageTypes.RETAILERS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.RETAILERS))
    : RetailerEmptyState,
  reducers: {
    setRetailers: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.RETAILERS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedRetailer: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(RetailerKey, result);
      return { ...state, ...action.payload };
    },
    updateSelectedDashboardRetailer: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(RetailerKey, result);
      return { ...state, ...action.payload };
    },
    resetRetailers: () => {
      clearLocalStorage('retailers');
      return RetailerEmptyState;
    },
  },
});

export const {
  setRetailers,
  updateSelectedRetailer,
  updateSelectedDashboardRetailer,
  resetRetailers,
} = retailersSlice.actions;
